import script from "./ProjectResourceSavingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectResourceSavingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectResourceSavingsPage.vue?vue&type=style&index=0&id=64b1d5bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b1d5bc"]])

export default __exports__